import { render, staticRenderFns } from "./saletotalSaleman.vue?vue&type=template&id=60d1d562&scoped=true&"
import script from "./saletotalSaleman.vue?vue&type=script&lang=js&"
export * from "./saletotalSaleman.vue?vue&type=script&lang=js&"
import style0 from "./saletotalSaleman.vue?vue&type=style&index=0&id=60d1d562&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d1d562",
  null
  
)

export default component.exports